// Copyright (c) 2020 embyt GmbH. All rights reserved.
// Author: Roman Morawek

import {
  CloudSettings,
  DeviceType,
  IUserChargingControl,
  UserAccessRights,
  UserSettings,
} from "dbtypes";
import { UserRole } from "graphql/api";

export interface AlarmSettings {
  offlineTimeout?: number; // s, until site offline alert triggers; zero to disable
  chargerOfflineTimeout?: number; // s, until charger offline alert triggers; zero to disable
  chargerFaultedTimeout?: number; // s, until charger connector faulted alert triggers; zero to disable
  chargingInterruptedSoc?: number; // %, charging interrupted alarm SoC limit; zero to disable
  emailAddress?: string;
  emailEnabled?: {
    [source: string]: boolean;
  };
}

export interface Site {
  id: number;
  name: string;
  serial: string;
  company: string | undefined;
  deviceType: DeviceType;
  deviceSw: string | undefined;
  tzOffset: number | undefined;
  ipAddresses: string | undefined;
  cloudSettings: CloudSettings | undefined;
  longitude: number | undefined;
  latitude: number | undefined;
}

export interface AwsUser {
  secId?: string;
  isRfidUser: boolean;
  email?: string;
  realName?: string;
}

export interface User {
  id: number;
  secId: string;
  email: string;
  role: UserRole;
  name: string;
  company: string | undefined;
  accessRights: UserAccessRights;
  // extended data, only available after extended request
  settings?: UserSettings | undefined;
  siteIds?: number[];
  chargingControl?: IUserChargingControl | undefined;
}

export interface IStateSite {
  user: AwsUser | undefined;
  siteList: Site[] | undefined;
  userList: User[] | undefined;
  tzOffset: number | undefined;
}

/* initial state */
export const INITIAL_STATE: IStateSite = {
  user: undefined,
  siteList: undefined,
  userList: undefined,
  tzOffset: undefined,
};
